import React from 'react';
import styles from './index.module.css';

const PasswordRequirements = ({ password }) => {
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = password && password.match(/[a-z]/);
  const hasNumber = password && password.match(/[0-9]/);
  const hasSpecialChar = password && password.match(/[!@#$%^&*()_+|~=`{}[\]:";'<>?,./]/);
  const hasValidLength = password && password.length >= 12 && password.length <= 30;

  const requirements = [
    {
      met: hasValidLength,
      text: 'Include 12-30 characters',
    },
    {
      met: hasUpperCase && hasLowerCase,
      text: 'Include atleast one upper case and one lower case',
    },
    {
      met: hasNumber && hasSpecialChar,
      text: 'Include atleast one number and special character',
    },
  ];

  return (
    <div className={styles.passwordRequirements}>
      {requirements.map((requirement, index) => (
        <div key={index} className={styles.requirementItem}>
          <svg
            className={styles.requirementIcon}
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke={requirement.met ? '#23e223' : '#94a3b8'}
            strokeWidth="2"
          >
            {requirement.met ? (
              <path d="M20 6L9 17l-5-5" />
            ) : (
              <circle cx="12" cy="12" r="10" />
            )}
          </svg>
          <span style={{ color: requirement.met ? '#23e223' : '#94a3b8' }}>
            {requirement.text}
          </span>
        </div>
      ))}
    </div>
  );
};

export default PasswordRequirements;
